import { Component, effect, input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CwButton } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Dialog } from '~/app/services/dialog.service';
import { dateAndTimeToMs, msToDateAndTime } from '~/app/utils/dateAndTimeToMs';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'gplus-prepared-edit-modal',
  imports: [DatepickerComponent, InputComponent, TranslateModule, CwButton],
  templateUrl: './prepared-edit-modal.component.html',
  styleUrl: './prepared-edit-modal.component.scss'
})
export class PreparedEditModalComponent {
  public dialog = input<Dialog>(null);

  public timeForm: FormGroup<{
    date: FormControl<Date>;
    hours: FormControl<string>;
  }> = new FormGroup({
    date: new FormControl<Date>(new Date()),
    hours: new FormControl<string>('')
  });

  constructor() {
    effect(() => {
      if (this.dialog()?.data?.prepared) {
        // Get hours and minutes with a zero if the value is less than 10
        const date = new Date(this.dialog()?.data.prepared);
        const time = msToDateAndTime(this.dialog()?.data.prepared).time;
        this.timeForm.patchValue({ date, hours: time });
      }
    });
  }

  public closeDialog(): void {
    this.dialog().confirm.next(false);
  }

  public submit() {
    const timestamp = dateAndTimeToMs(this.timeForm?.controls?.date?.value, this.timeForm?.controls?.hours?.value);
    if (!timestamp) {
      console.warn('PreparedEditModalComponent: Invalid date or time');
      return;
    }

    this.dialog().confirm.next({ prepared: timestamp });
  }
}
